import Contact from "../Miscellanous/Contact";

export default Contact;